import { FormControl, FormLabel, TextField } from '@mui/material';

import { AutocompleteWithNew } from '@/components/shared/autocompleteWithNew';
import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

export const NetworkInterfaceSelect = ({
  accountId,
  resourceGroup,
  networkInterface,
  location,
  onChange,
}: {
  accountId?: string;
  resourceGroup?: string;
  networkInterface?: string;
  location?: string;
  onChange: (networkInterface: string) => void;
}) => {
  const title = 'Network Interface';
  if (!accountId || !resourceGroup || !location) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerNetworkInterfaceSelect
      accountId={accountId}
      resourceGroup={resourceGroup}
      networkInterface={networkInterface}
      location={location}
      onChange={onChange}
      title={title}
    />
  );
};

const InnerNetworkInterfaceSelect = ({
  accountId,
  resourceGroup,
  networkInterface,
  location,
  onChange,
  title,
}: {
  accountId: string;
  resourceGroup: string;
  networkInterface?: string;
  location: string;
  onChange: (networkInterface: string) => void;
  title: string;
}) => {
  const dal = useDAL();
  const { data: body } =
    dal.restore.azureRestoreConfig.useListNetworkInterfaces(
      accountId,
      resourceGroup
    );
  const regionNics =
    body?.networkInterfaces
      .filter((ni) => ni.location === location)
      .map((ni) => ni.name) ?? [];

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <AutocompleteWithNew
        clearOnBlur
        size='small'
        value={networkInterface || null}
        onChange={(event, newValue) => onChange(newValue || '')}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder='Select'
            label=''
            slotProps={{ inputLabel: { shrink: true } }}
          />
        )}
        options={regionNics}
      />
    </FormControl>
  );
};
